fx.ns("shared.popups", class ConfirmLeaveWithoutSaving extends shared.popups.BasePersonPopup{
    
    constructor()
    {
        super(fx.get("assets").personSure )
        this.contentWidth = 550;
        this.contentHeight = 200;
    }

    create()
    {
        super.create();
 
        this.addChild(new fx.components.Text({text:fx.text("Etes-vous sûre de vouloir quitter ?"), className:"title center"}));
        this.addChild(new fx.components.Text({text:fx.text("Si vous quittez maintenant, votre album ne sera pas sauvegardé."), className:"text center"}));

        this.okButton = new fx.components.Button({label : fx.text("Quitter"), type : "filled"});
        this.cancelButton = new fx.components.Button( {label :fx.text("Attendre")} );

        this.addFooterChild(this.cancelButton, {width : 200})
        this.addFooterChild(this.okButton, {width : 200})
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onConfirm, this.okButton);
        this.on("click", this.close, this.cancelButton);
    }

    onConfirm()
    {
        this.trigger("confirmed");
        this.close();
    }

});